"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgFinish(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 -4 14 24" }, props),
        React.createElement("path", { d: "M5 0v16h2v-6h12V0zm2 2h2v2h2V2h2v2h2V2h2v1.973L15 4v2h2v2h-2V6h-2v2h-2V6H9v2H7V6h2V4.027H7zm4 4h2V4h-2z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Finish')(SvgFinish);
//# sourceMappingURL=Finish.js.map